<template>
    <div>
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">调拨单信息</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>基本信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>调拨单号</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.no}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>来源单据号</span></div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{stuffTransVoucher.srcVoucherNo || "无"}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>外部单据号</span>
                        </div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">
                            <span>{{stuffTransVoucher.outerNo || "无"}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.creatorComName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">调出机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.srcBizUnitName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">调入机构</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.dstBizUnitName}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建时间</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.createTime}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建人</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.creatorName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">审核公司</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.auditComName || '无'}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">审核人</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.auditorName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">确认人</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.confirmerName}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">申请描述</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.applyDesc || '无'}}</div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">审核原因</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.auditDesc || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">确认描述</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.confirmDesc || '无'}}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 60px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">备注</div>
                        <div class="value" style="padding-left: 54px;white-space: normal; word-break: break-all;">{{stuffTransVoucher.memo || '无'}}</div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div style="overflow: hidden;border: 1px solid rgb(26, 26, 26);margin-top: 10px;" v-for="item in stuffTransVoucher.itemList">
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>系统编号</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.tmpNo}}</div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>资产描述全称</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.title}}</div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>名称</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.name}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>型号</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.model || ""}}</div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>规格</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.fixedSpec || ""}}</div>
            </div>

            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>分类</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.catName}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>分类分组</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{getDevcGroupNameByCatId(item.catId)}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>品牌</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.brandName}}</div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调出部门</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.srcComName}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调出仓库</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.srcWarehouseName}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调入部门</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.dstComName}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调入仓库</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.dstWarehouseName}}</span>
                </div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调拨可用数量</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">
                    <span>{{item.quantity - item.quantity2}}</span>
                </div>
            </div>
            <div v-if="stuffTransVoucher.assetType != 2" style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>调拨报废/弃用数量</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.quantity2 || 0}}</div>
            </div>
            <div style="overflow: hidden;width: 33.33%;float: left;margin-top: 5px;font-size: 12px">
                <div style="width: 60px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                    <label>备注</label>
                </div>
                <div style="padding-left: 54px; white-space: normal;word-break: break-all;word-wrap: break-word;color:#666666;">{{item.memo}}</div>
            </div>
        </div>
    </div>

</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import { getDevcGroupNameByCatId } from '../index'
    import { showHtmlToPdfDlg } from '../ctrl/dialog'
    //
    import shopStuffApi from '../../api/shopStuff'

    export default {
        name: 'swb-stuff-trans-voucher-for-pdf',
        desc: '调拨单导出',
        props: {
            voucherId: {
                type: Number,
                deafult: null,
            },
        },
        data: function () {
            return {
                stuffTransVoucher: {},
                itemList: [],
            }

        },
        created: function () {
            this.getStuffTransVouhcer();
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            getStuffTransVouhcer: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                let theLoading = MsgBox.loading();
                shopStuffApi.getStuffTransVoucherInfo(postData, function (result) {
                    theLoading.close();
                    if(result.type == "info") {
                        let stuffTransVoucher = result.data;
                        self.stuffTransVoucher = stuffTransVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },

            getHtml: function () {
                return this.$el.outerHTML;

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/StuffTransVoucherForPdf.vue